import React from "react";
import "./reporting.css";
import "../Dashboard/dashboard.css";
import { useDispatch, useSelector } from "react-redux";
import RingLoaderShared from "../../shared/RingLoader/RingLoader";

const MFE2_Stat = React.lazy(
  () => import('Child/Stat')
);

const Reporting = () => {
  const { isOpen, prevPage } = useSelector((state) => state.design);
  const dispatch = useDispatch();

  function displaySection2() {
    // dispatch(changeStyle(true, 2, true))

    // Array.from(document.getElementsByClassName("center-icon")).forEach(
    //   (element) => {
    //     element.style.visibility = "hidden";
    //   }
    // );
    // Array.from(document.getElementsByClassName("section-background")).forEach(
    //   (element) => {
    //     element.style.opacity = "1";
    //   }
    // );

    // document.getElementById("reporting").setAttribute("data-boolean", "false");
    // document.getElementsByClassName("container-dashboard")[1].style.width = "100%";


    // document.getElementById("qualityManagment").style.zIndex = "1";
    // document.getElementById("qualityManagment").style.display = "none";


    // document.getElementById("managment").style.zIndex = "1";
    // document.getElementById("managment").style.display = "none";


    // document.getElementById("qualityMonotoring").style.zIndex = "1";
    // document.getElementById("qualityMonotoring").style.display = "none";
  }

  return (
    <>
      {/* <div
        className={clsx({ 'div-reporting': isOpen && prevPage === 'home' }, { 'spacing-reporting': isOpen })}

        data-boolean="true"
        style={{ height: 'auto' }}
      >
        <div className="container container-dashboard emplacement-reporting ">
          <div className="section-background"> */}
      {/* <Navbar>
                <Container>
                  <Navbar.Brand href="#home" style={{ color: "#F5714F" }}>
                    <img
                      alt=""
                      src={stat}
                      width="40"
                      height="40"
                      className="d-inline-block align-top"
                      style={{ marginRight: "15px" }}
                    />
                    Statistique
                  </Navbar.Brand>
                </Container>
              </Navbar> */}
      <React.Suspense fallback={<RingLoaderShared />}>
        <MFE2_Stat newInstance={true} />
      </React.Suspense>
      {/* </div>

        </div>
      </div> */}
    </>
  );
};

export default Reporting;
